export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: false
        },
        actionsPTBD: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'search'
            }
        ],
        formActions: [],
        rowActions: [],
        headerFieldsPTBD: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,

            },
            {
                name: "doctorName",
                label: "Orvos",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "patientCount",
                label: "Betegforgalom",
                filter: {
                    type: "simple",
                },
                visibility: true,
            }
        ]
    }
}
